import React, { useState, useEffect } from "react";
import styles from "./MemberShipPlan.module.scss";
import BillDetailsModal from "../BillingComp/BillDetailsModal";
import Loader from "../../../components/Loader/Loader";

const MemberShipPlan = ({ onClose, userDetail }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [plans, setPlans] = useState([]);
  const [isBillModalOpen, setIsBillModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [loading, setLoading] = useState(true);
  const handleClose = () => {
    setIsOpen(false);
    if (onClose) onClose();
  };

  // Function to format amount into K format
  const formatAmount = (amount) => {
    const num = parseInt(amount);
    if (num >= 1000) {
      return `${num / 1000}K`;
    }
    return amount;
  };

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          "https://ballersapi.ballerslife.co/api/v1/memberships/membership/payment_plans/active",
          {
            method: "GET",
            headers: {
              accept: "application/json",
              Authorization:
                "Bearer YmFsbGVyc29mZmljaWFsbGl2ZXdlYnNpdGV0b2tlbjIwMjQ=",
            },
          }
        );
        const data = await response.json();
        setPlans(data.active_payment_plans);

        // Set the first plan's ID to be expanded by default
        if (data.active_payment_plans.length > 0) {
          setExpandedAccordion(data.active_payment_plans[0].id);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    };

    fetchPlans();

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
    setIsBillModalOpen(true);
  };

  const toggleAccordion = (planId) => {
    setExpandedAccordion(expandedAccordion === planId ? null : planId);
  };

  return (
    isOpen && (
      <div className={styles.modalBallersOverlay} onClick={handleClose}>
        <div
          className={styles.modalBallersContent}
          onClick={(e) => e.stopPropagation()}
        >
          <button className={styles.closeButton} onClick={handleClose}>
            ×
          </button>
          <h2>Membership Plans</h2>
          <>
            {loading ? (
              <Loader />
            ) : (
              <>
                {windowWidth >= 960 ? (
                  <table className={styles.membershipBallersTable}>
                    <thead>
                      <tr>
                        <th>Features</th>
                        {plans.map((plan) => (
                          <th key={plan.id}>{plan.plan_name}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Access Locations</td>
                        {plans.map((plan) => (
                          <td key={plan.id}>{plan.access_loc}</td>
                        ))}
                      </tr>
                      <tr>
                        <td>Unlimited Bookings</td>
                        {plans.map((plan) => (
                          <td key={plan.id}>
                            {plan.unlimited_bookings === "true" ? "Yes" : "No"}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td>Tournaments Access</td>
                        {plans.map((plan) => (
                          <td key={plan.id}>{plan.tournament_access}</td>
                        ))}
                      </tr>

                      <tr>
                        <td>Guest Passes</td>
                        {plans.map((plan) => (
                          <td key={plan.id}>{plan.guest_pass}</td>
                        ))}
                      </tr>
                      <tr>
                        <td>Booking Support</td>
                        {plans.map((plan) => (
                          <td key={plan.id}>{plan.booking_support}</td>
                        ))}
                      </tr>
                      <tr>
                        <td>Singles Privilege</td>
                        {plans.map((plan) => (
                          <td key={plan.id}>{plan.singles_privilege}</td>
                        ))}
                      </tr>
                      <tr>
                        <td>Community Access</td>
                        {plans.map((plan) => (
                          <td key={plan.id}>{plan.community_access}</td>
                        ))}
                      </tr>
                      <tr>
                        <td>Validity</td>
                        {plans.map((plan) => (
                          <td key={plan.id}>{plan.validity}</td>
                        ))}
                      </tr>
                      <tr>
                        <td></td>
                        {plans.map((plan) => (
                          <td key={plan.id}>
                            <button
                              className={styles.selectBallersButton}
                              onClick={() => handleSelectPlan(plan)}
                            >
                              Select Plan
                            </button>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <div className={styles.accordionContainer}>
                    {plans.map((plan) => (
                      <div key={plan.id} className={styles.accordionItem}>
                        <div
                          className={`${styles.accordionHeader} ${
                            expandedAccordion === plan.id ? styles.active : ""
                          }`}
                          onClick={() => toggleAccordion(plan.id)}
                        >
                          <div className={styles.planTitle}>
                            {plan.plan_name}
                          </div>
                          <span className={styles.arrow}>
                            {expandedAccordion === plan.id ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-chevron-up-icon lucide-chevron-up"
                              >
                                <path d="m18 15-6-6-6 6" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-chevron-down-icon lucide-chevron-down"
                              >
                                <path d="m6 9 6 6 6-6" />
                              </svg>
                            )}
                          </span>
                        </div>
                        {expandedAccordion === plan.id && (
                          <div className={styles.accordionContent}>
                            <div className={styles.featureItem}>
                              <span className={styles.featureLabel}>
                                Access Locations:
                              </span>
                              <span className={styles.featureValue}>
                                {plan.access_loc}
                              </span>
                            </div>
                            <div className={styles.featureItem}>
                              <span className={styles.featureLabel}>
                                Unlimited Bookings:
                              </span>
                              <span className={styles.featureValue}>
                                {plan.unlimited_bookings === "true"
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                            <div className={styles.featureItem}>
                              <span className={styles.featureLabel}>
                                Tournaments Access:
                              </span>
                              <span className={styles.featureValue}>
                                {plan.tournament_access}
                              </span>
                            </div>

                            <div className={styles.featureItem}>
                              <span className={styles.featureLabel}>
                                Guest Passes:
                              </span>
                              <span className={styles.featureValue}>
                                {plan.guest_pass}
                              </span>
                            </div>
                            <div className={styles.featureItem}>
                              <span className={styles.featureLabel}>
                                Booking Support:
                              </span>
                              <span className={styles.featureValue}>
                                {plan.booking_support}
                              </span>
                            </div>
                            <div className={styles.featureItem}>
                              <span className={styles.featureLabel}>
                                Singles Privilege:
                              </span>
                              <span className={styles.featureValue}>
                                {plan.singles_privilege}
                              </span>
                            </div>
                            <div className={styles.featureItem}>
                              <span className={styles.featureLabel}>
                                Community Access:
                              </span>
                              <span className={styles.featureValue}>
                                {plan.community_access}
                              </span>
                            </div>
                            <div className={styles.featureItem}>
                              <span className={styles.featureLabel}>
                                Validity:
                              </span>
                              <span className={styles.featureValue}>
                                {plan.validity}
                              </span>
                            </div>
                            <div className={styles.buttonContainer}>
                              <button
                                className={styles.selectBallersButton}
                                onClick={() => handleSelectPlan(plan)}
                              >
                                Select Plan
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </>
          {isBillModalOpen && selectedPlan && (
            <BillDetailsModal
              onClose={() => setIsBillModalOpen(false)}
              parentOnClose={handleClose}
              planName={selectedPlan.plan_name}
              amount={selectedPlan.amount}
              gst={selectedPlan.gst_18}
              total={selectedPlan.amount_with_taxes}
              planId={selectedPlan.plan_id}
            />
          )}
        </div>
      </div>
    )
  );
};

export default MemberShipPlan;
